// Lib
import { createAction } from '@reduxjs/toolkit';

export const SetLoading = createAction('SET_LOADING');
